import { hasFamousOwners } from '../../domain/cars/carOwners';
import CarGallery from './CarGallery';
import CarOwners from './CarOwners';
import CarProse from './CarProse';

/**
 * THE REST OF THE CAR — everything the stats screen above is not
 * (SPEC-004 PR-4.9).
 *
 * What one has been worth, what the car IS, why it is a legend, the fun facts,
 * the design note, the people who owned one, and the pictures. It reads in one
 * order and answers one question at a time.
 *
 * IT IS NOT FOLDED, and that reverses the way this component shipped. It was a
 * disclosure — a handle at the foot of the screen that a reader pulled or
 * pressed, with the page scrolling itself to what had just appeared — modelled
 * on the sibling product's card. The argument for it was that the stats screen
 * is a self-contained object and the long read is a different thing.
 *
 * That was true and it did not matter. A catalogue is READ, and the one gesture
 * every reader already knows for "show me more of this" is scrolling. A fold
 * asks them to discover a control first, costs a tap before any of the writing
 * can be reached, and hides most of the page from anyone skimming — for a
 * benefit that only exists on the first screenful. The page is long; a long page
 * is what this is.
 *
 * So this is a plain run of bands now. No state, no gesture, no handle, nothing
 * to carry the reader to: the content is simply there, under the screen, in the
 * order it has always been in.
 *
 * Every band still hides ITSELF where its content is missing, which is the rule
 * that has not changed — a heading over nothing is worse than a heading that is
 * not there. Those guards are stated here as well as inside each component,
 * because this file is where the page's order is legible.
 */
export default function CarDossier({ car, onOpenTake }) {
    return (
        <div className="car-dossier">
            {/* The value band used to open this read. It is on the stats
                screen now, under the acceleration graph — the two plots belong
                together, and the fold is no longer the only place with room for
                one (SPEC-015). */}
            <CarProse car={car} />

            {/* After the prose and before the pictures. The band is a footnote
                to what the car IS — it only means anything once a reader knows
                why an F40 is worth being given one — and the gallery is the
                page's closing image either way. */}
            {hasFamousOwners(car) ? <CarOwners car={car} /> : null}

            {/* Renders nothing at all, silently, for the eleven cars that
                arrived as a single side profile. */}
            <CarGallery car={car} onOpenTake={onOpenTake} />
        </div>
    );
}
